import { Box, Typography } from '@mui/material';
import { ResponsiveBar } from '@nivo/bar';
import { chartTheme, LABEL_COLOR } from '../constants';
import type { MaterialChartRow } from '../types';

export const RoofTypeMaterialChart = ({
    data,
}: {
    data: MaterialChartRow[];
}) => {
    if (data.length === 0 || data.every(row => row.count === 0)) {
        return (
            <Box
                sx={{
                    height: 160,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography sx={{ color: LABEL_COLOR, fontSize: 12 }}>No material breakdown</Typography>
            </Box>
        );
    }

    const maxValue = Math.max(0, ...data.map(row => row.count));
    const tickStep = Math.max(1, Math.ceil(maxValue / 3));
    const tickValues: number[] = [];
    for (let v = 0; v <= maxValue; v += tickStep) {
        tickValues.push(v);
    }
    if (tickValues[tickValues.length - 1] !== maxValue && maxValue > 0) {
        tickValues.push(maxValue);
    }

    return (
        <Box sx={{ height: 160 }}>
            <ResponsiveBar
                data={data}
                keys={['count']}
                indexBy="material"
                groupMode="grouped"
                layout="horizontal"
                margin={{ top: 0, right: 16, bottom: 18, left: 60 }}
                padding={0.35}
                innerPadding={4}
                colors={({ indexValue }) => {
                    const material = String(indexValue).toLowerCase();
                    if (material === 'metal') return '#22C55E';
                    if (material === 'tile') return '#0EA5E9';
                    if (material === 'shingle') return '#F59E0B';
                    if (material === 'wood') return '#A16207';
                    if (material === 'concrete') return '#6B7280';
                    return '#22C55E';
                }}
                borderRadius={6}
                enableLabel
                labelSkipWidth={0}
                valueFormat={v => `${Math.round(Number(v))}`}
                label={d => `${Math.round(Number(d.value))}`}
                labelTextColor="#fff"
                axisBottom={{
                    tickSize: 0,
                    tickPadding: 4,
                    tickValues,
                    format: v => `${Math.round(Number(v))}`,
                }}
                axisLeft={{ tickSize: 0, tickPadding: 4 }}
                enableGridY={false}
                gridXValues={tickValues}
                theme={chartTheme}
            />
        </Box>
    );
};
